import {
  useGetUserRealWorldConnections,
  useDeleteRealWorldConnection,
  getGetUserRealWorldConnectionsQueryKey,
  useGetTopRealWorldConnections,
  likeRealWorldConnection,
  unlikeRealWorldConnection,
  getGetTopRealWorldConnectionsQueryKey,
} from "@packages/api/madlenAPI";
import {
  Connection,
  ConnectionCard,
} from "../../components/connections/ConnectionCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";

interface ExtendedTool {
  id: number;
  title?: string;
  imageUrl?: string;
  prompt?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  videoUrl?: string;
  didUserLiked?: boolean;
  description?: string;
  connections?: Connection[];
  createdAt?: string;
  isEditable?: boolean;
  contentLanguage?: string;
}

const ConnectionDetailComponent = ({ tool }: { tool: ExtendedTool }) => {
  return (
    <ConnectionCard
      id={tool.id.toString()}
      courseName={tool.courseName!}
      prompt={tool.title || tool.prompt!}
      gradeLevel={tool.gradeLevel!}
      connections={tool.connections || []}
      imageUrl={tool.imageUrl!}
      videoUrl={tool.videoUrl}
      isImageLoading={false}
      createdAt={tool.createdAt ?? ""}
      author={tool.authorName!}
      contentLanguage={tool.contentLanguage!}
      isEditable={tool.isEditable}
    />
  );
};

const ConnectionsView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserRealWorldConnections}
      useDeleteTool={useDeleteRealWorldConnection}
      getGetToolsQueryKey={getGetUserRealWorldConnectionsQueryKey}
      useGetTopTools={useGetTopRealWorldConnections}
      likeTool={likeRealWorldConnection}
      unlikeTool={unlikeRealWorldConnection}
      getGetTopToolsQueryKey={getGetTopRealWorldConnectionsQueryKey}
      toolType="connections"
      toolPath="connections"
      DetailComponent={ConnectionDetailComponent}
      colors={{
        light: "from-orange-600 to-red-600",
        dark: "dark:from-orange-400 dark:to-red-400",
        iconBg: "bg-orange-100 dark:bg-orange-900/50",
        iconColor: "text-orange-600 dark:text-orange-400",
        hover: "hover:bg-orange-50 dark:hover:bg-orange-900/20",
      }}
      toolColor="orange"
      gradientColor="sky"
    />
  );
};

export default ConnectionsView;
